import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaExclamationTriangle,
  FaClock,
  FaWarehouse,
  FaWrench,
  FaTachometerAlt,
  FaChevronLeft,
  FaChevronRight,
  FaToolbox,
  FaListAlt,
  FaUsers,
  FaBarcode,
  FaCreditCard,
  FaTruck,
} from "react-icons/fa";
import '../styles/Sidebar.css';

const AssistantSidebar = ({ user }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className={`admin-sidebar ${isCollapsed ? 'collapsed' : ''}`}>

      {/* Toggle Button */}
      <button 
        className="sidebar-toggle-btn" 
        onClick={() => setIsCollapsed(!isCollapsed)}
        title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
      </button>

    
      

      {/* Navigation */}
      <nav className="sidebar-nav">

        <NavLink to="/" className="nav-btn" title="Dashboard">
          <FaTachometerAlt className="nav-icon" />
          {!isCollapsed && <span>Dashboard</span>}
        </NavLink>

        <NavLink to="/breakdown-requests" className="nav-btn" title="Breakdown Requests">
          <FaExclamationTriangle className="nav-icon" />
          {!isCollapsed && <span>Breakdown Requests</span>}
        </NavLink>

        <NavLink to="/extension-requests" className="nav-btn" title="Extensions & Releases">
          <FaClock className="nav-icon" />
          {!isCollapsed && <span>Extensions & Releases</span>}
        </NavLink>

        <NavLink to="/assets" className="nav-btn" title="Asset Management">
          <FaWarehouse className="nav-icon" />
          {!isCollapsed && <span>Asset Inventory</span>}
        </NavLink>

        <NavLink to="/maintenance" className="nav-btn" title="Maintenance">
          <FaWrench className="nav-icon" />
          {!isCollapsed && <span>Maintenance</span>}
        </NavLink>

        <NavLink to="/issues" className="nav-btn" title="Issue Dashboard">
          <FaListAlt className="nav-icon" />
          {!isCollapsed && <span>Issue Dashboard</span>}
        </NavLink>

       

        <NavLink to="/asset-management" className="nav-btn" title="Manage Asset Requests">
          <FaToolbox className="nav-icon" />
          {!isCollapsed && <span>Manage Asset Requests</span>}
        </NavLink>

        <NavLink to="/manage-asset-users" className="nav-btn" title="Manage Asset Users">
          <FaUsers className="nav-icon" />
          {!isCollapsed && <span>Manage Asset Users</span>}
        </NavLink>

        <NavLink to="/manage-suppliers" className="nav-btn" title="Manage Suppliers">
          <FaTruck className="nav-icon" />
          {!isCollapsed && <span>Manage Suppliers</span>}
        </NavLink>

        <NavLink to="/generate-barcode" className="nav-btn" title="Create Barcode">
          <FaBarcode className="nav-icon" />
          {!isCollapsed && <span>Generate Barcode</span>}
        </NavLink>

        <NavLink to="/lab-admin/dashboard?section=view-plans" className="nav-btn" title="View Plans">
          <FaCreditCard className="nav-icon" />
          {!isCollapsed && <span>View Plans</span>}
        </NavLink>

      </nav>

    </div>
  );
};

export default AssistantSidebar;